import {CheckCheck} from 'lucide-react'
import React from 'react'

import {Message} from '../../ChatbotPage'

interface UserMessageProps {
  message: Message
  /**
   * Put text back in the composer so the user can correct it. Kept in the contract
   * for callers, but currently unused: the "Not what I meant" affordance under the
   * bubble is not rendered (see the note at the bottom of the component).
   */
  onCorrect?: (text: string) => void
}

const UserMessage: React.FC<UserMessageProps> = ({message}) => {
  const timestamp = message.timestamp ? new Date(message.timestamp as any) : new Date()

  const imageMatch = message.text?.match(/!\[[^\]]*\]\(([^)]+)\)/)
  const imageUrl = imageMatch ? imageMatch[1] : null

  return (
    <div className='chatbot-message-row chatbot-message-row--user'>
      <div className='chatbot-user-bubble'>
        {imageUrl ? (
          <div>
            <img
              src={imageUrl}
              alt='Uploaded'
              style={{
                maxWidth: '100%',
                maxHeight: '300px',
                borderRadius: '8px',
                marginBottom: '8px',
                display: 'block',
              }}
            />
          </div>
        ) : (
          <p>{message.text}</p>
        )}
        <div className='chatbot-user-bubble__footer'>
          <span className='chatbot-user-bubble__time'>
            {timestamp.toLocaleTimeString([], {
              hour: '2-digit',
              minute: '2-digit',
            })}
          </span>
          <CheckCheck size={14} className='chatbot-user-bubble__read' aria-hidden='true' />
        </div>
      </div>

      {/* The "Searched for <rewritten query> / Not what I meant" line under the bubble is
          intentionally not rendered: the server also rewrites plain-English questions
          (e.g. "Was Wendy 9 present…"), so it read as noise under every message.
          `message.understoodAs` is still attached by the chat hooks and stays available
          should the line ever come back. */}
    </div>
  )
}

export default UserMessage
